import React, { useEffect, useRef, useState } from 'react';
import useAPI from '../../../hooks/useAPI';
import Modal from '../../layout/Modal';
import { sendToast} from "../../plugins/toastAll";
import FilterContacts from './FilterContacts';
import styled from "styled-components";
import { BsSearch } from 'react-icons/bs';
import { IoClose } from 'react-icons/io5';
import { IoMdClose } from 'react-icons/io';
import { FaSpinner } from 'react-icons/fa';
import { HiAdjustmentsHorizontal } from 'react-icons/hi2';

const ContactList = ({ 
    Botton,
    setShowContacts,
    stageSelected,
    searchQuery,
    onSearchPersons,
    loadingContacts,
    setListPersons,
    listPersons,
    getStages,
    setStageSelected,
    setLoading,
    Alert,
    correspondence,
    listTags,
    setLoadingContacts,
    searchTerm
}) => {
    const [searchPersons, setSearchPersons] = useState("");
    const [modalFilter, setModalFilter] = useState(false);
    const [segments, setSegments] = useState([]);
    const [segmentsValidate, setSegmentsValidate] = useState(false);
    
    const userLogout = localStorage.getItem("USER_NAME");

    const { urlAPI_1, urlAPI_2, urlAPI_3, urlSocket, fetchWithAuth } = useAPI();

    const clearSearch = () => {
        setSearchPersons("");
        setSelectAll(false);
        searchQuery(true);
    };

    const addPersonStage = async (e) => {
        console.log('VALUE----->', e.target.value);
        console.log('stageSelected------>', stageSelected);
        const findUser = stageSelected.prospects.find(prospect => prospect._id == e.target.value)
        console.log('findUser------>', findUser);
        if(!findUser) {
            try {
                console.log('stageSelected.prospects------>', stageSelected.prospects);
                const prospects = [
                    e.target.value,
                    ...stageSelected.prospects.map(prospect => {
                        if(typeof prospect === 'object') {
                            return prospect._id
                        }
                    }) 
                ]
                console.log('prospects------>', prospects);
                const dataStage = {
                    prospect: e.target.value,
                    data: {
                        ...stageSelected,
                        prospects: prospects
                    }
                }
                console.log('dataStage------>', dataStage);

                setLoading(true);
                const url = urlAPI_3 + `stagesAddProspect/${stageSelected._id}`;
                const options = { method: "PUT", mode: "cors", body: JSON.stringify(dataStage)};
                const response = await fetchWithAuth(url, options);
                const result = await response.json();
                console.log("Result of the API: stagesAddProspect/{id}:", result);
                
                await getStages();
                setStageSelected({ ...result.data, prospects: [...result.data.prospects] });
                // setAddNewStage(false);
                // setIsDisableSelect(true);
                setLoading(false);
                sendToast(result)
            } catch (error) {
                console.log(error);
            }
        } else {
            return sendToast({type: "success", message: "El contacto ya se encuentra en esta etapa, por lo tanto no se puede volver a guardar."})
        }
    }

    // 1. Agrega este estado
    const [selectAll, setSelectAll] = useState(false);

    // 2. Agrega esta función
    const addAllPersonsStage = async () => {
        const personsToAdd = listPersons.filter(
            person => !stageSelected.prospects?.some(stage => stage._id === person._id)
        );

        if (personsToAdd.length === 0) {
            setSelectAll(true);
            return;
        }

        try {
            setLoading(true);

            const existingIds = stageSelected.prospects.map(prospect => 
                typeof prospect === 'object' ? prospect._id : prospect
            );

            const newIds = personsToAdd.map(p => p._id);
            const allProspectIds = [...existingIds, ...newIds];

            const dataStage = {
                prospects_to_remove: newIds,  // ← array de IDs a limpiar de otros stages
                data: {
                    ...stageSelected,
                    prospects: allProspectIds
                }
            };

            const url = urlAPI_3 + `stagesAddProspect/${stageSelected._id}`;
            const options = { method: "PUT", mode: "cors", body: JSON.stringify(dataStage) };
            const response = await fetchWithAuth(url, options);
            const result = await response.json();

            await getStages();
            setStageSelected({ ...result.data, prospects: [...result.data.prospects] });
            setLoading(false);
            setSelectAll(true);
            sendToast(result);

        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    return (
        <>
            <div className="prospect-info m-1">
                <div className='module-chat info active h-100 mb-2'>
                    <header className="message d-flex" style={{height:"6%"}}>
                        <div className="d-flex">
                            <div style={{ alignItems: "center", display: "flex" }}>
                                <Botton
                                    type="button"
                                    onClick={() => {
                                        setShowContacts(false)
                                    }}
                                >
                                    <IoClose className="icon-cancel" style={{ fontSize: "1.5rem" }} />
                                </Botton>
                            </div>
                            <div id="customer-name" className="ml-2 d-flex">
                                <h1>{"Agregar contactos a " + stageSelected.name}</h1>
                            </div>
                        </div>
                    </header>
                    <div className="w-100 d-flex justify-content-center align-items-center" style={{height:"5%"}}>
                        <form 
                            className="form-inline justify-content-center" 
                            onSubmit={(e) => {
                                e.preventDefault();
                                searchQuery();
                            }}
                        >
                            <div className="su-control mt-1 d-flex">
                                <input
                                    className="form-control w-100"
                                    type="text"
                                    placeholder="Búsqueda"
                                    value={searchPersons}
                                    onChange={(e) => {
                                        setSearchPersons(e.target.value);
                                        onSearchPersons(e);
                                    }}
                                />
                                {searchPersons && (
                                    <ClearIcon 
                                        onClick={clearSearch}
                                    />
                                )}
                                <button
                                    className="ml-1 btn btn-info"
                                    type="button"
                                    id="buttonSearchProductBack"
                                    style={{ height: "34px" }}
                                    onClick={() => {
                                        searchQuery();
                                    }}
                                >
                                    <BsSearch />
                                </button>                
                            </div>
                        </form>

                        <div style={{ position: "relative", display: "flex" }}>
                            <HiAdjustmentsHorizontal
                                className="icon-filter-2 f-36 pointer ml-2"
                                data-tooltip-id="my-tooltip" data-tooltip-content="Filtrar contactos"
                                onClick={() => {
                                    setModalFilter(true);
                                    setSelectAll(false);
                                }}
                            />
                            {segments.length > 0 && (
                                <div
                                    className="number-messages"
                                    style={{
                                        fontSize: "12px",
                                        position: "absolute",
                                        top: "-4px", // Ajusta según sea necesario
                                        right: "-8px", // Ajusta según sea necesario
                                        backgroundColor: "#00a884",
                                        color: "white",
                                        borderRadius: "50%",
                                        padding: "0px 5px",
                                        width: "18px",
                                        height: "18px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    {segments.length}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="mt-3" style={{height:"90%"}}>
                        {segments.length > 0 && !loadingContacts && listPersons.length > 0 && (
                            <div className="d-flex align-items-center m-2 mb-3">
                                <input
                                    type="checkbox"
                                    id="select-all"
                                    className="cmn-toggle cmn-toggle-round-flat"
                                    checked={selectAll}
                                    onChange={() => {
                                        if (!selectAll) {
                                            addAllPersonsStage();
                                        }
                                    }}
                                />
                                <label className="mb-0" htmlFor="select-all" ></label>
                                <label htmlFor="select-all" className="mb-0 pointer">
                                    Seleccionar todos ({listPersons.length} contactos)
                                </label>
                            </div>
                        )}
                        {loadingContacts && (
                            <>
                                <h4 className="text-center">Cargando registros...</h4>
                                <span className="d-flex justify-content-center">
                                    <FaSpinner
                                        id="spinner-list-conv"
                                        className="fa-spin"
                                        style={{ fontSize: "23px" }}
                                    />
                                </span>
                            </>
                        )}
                        <ul className="content-list-contacts" style={{ height: "100%", overflowY: "auto" }}>
                            {listPersons.map((person) => {                       
                                const isActive = stageSelected.prospects?.some(stage => stage._id === person._id);
                                return (
                                    <li className="d-flex justify-content-between align-items-center m-2" key={person._id}>
                                        <label className="mb-0">
                                            {(person.name && person.name.length > 28) ? person.name.substr(0, 28) + "..." : person.name}
                                        </label>
                                        <div>
                                            <input
                                                type="checkbox"
                                                value={person._id}
                                                className="cmn-toggle cmn-toggle-round-flat"
                                                name={person._id }
                                                id={person._id}
                                                checked={isActive}
                                                // defaultChecked={isActive}
                                                // {...register("tags")}
                                                onChange={(e) => {
                                                    addPersonStage(e);
                                                }}
                                            />
                                            <label className="mb-0" htmlFor={person._id}></label>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>

            {/* Modal para filtrar contactos */}
            <Modal
                status={modalFilter}
                changeStatus={setModalFilter}
                title='Filtrar contactos'
                width={"800px"}
            >
            <Content>
                <FilterContacts 
                    setModalFilter={setModalFilter}
                    setSegments={setSegments}
                    segments={segments}
                    listTags={listTags}
                    setSegmentsValidate={setSegmentsValidate}
                    segmentsValidate={segmentsValidate}
                    Alert={Alert}
                    correspondence={correspondence}
                    setListPersons={setListPersons}
                    setLoadingContacts={setLoadingContacts}
                    searchTerm={searchTerm}
                />
            </Content>
            </Modal>
        </>
    )
}

export default ContactList;

const Div = styled.div`
    label {
        font-size: 14px;
    }

    input,
    textarea {
        font-size: 1em;
    }
`;
const Content = styled.div`
  // display: flex;
  // flex-direction: column;
  // align-items: center;
    h1 {
        font-size: 42px;
        font-weight: 700;
        margin-bottom: 10px;
        text-align: center;
    }
    li {
        padding: 10px 5px;
        border-bottom: 1px solid rgb(0, 0, 0, 0.05);
    }
    li:hover {
        background: rgb(0, 0, 0, 0.05);
    }
    p {
        font-size: 18px;
        margin-bottom: 0px;
    }
    input {
        padding: 10px;
        border-radius: 0px;
        font-size: 17px;
    }
    img.img-answer {
        cursor: pointer;
        width: auto;
        height: 85px;
        object-fit: scale-down;
    }
    .content-img {
        position: relative;
    }
    .content-img img:hover {
        opacity: 0.6;
    }
`;

const ClearIcon = styled(IoMdClose)`
    margin-left: -1.7rem;
    margin-top: 0.2rem;
    font-size: 30px;
    cursor: pointer;
    color: gray;
    
    &:hover {
        color: black;
    }
`;